import { render, staticRenderFns } from "./ModalOrderReturn.vue?vue&type=template&id=48ae256a&scoped=true&"
import script from "./ModalOrderReturn.vue?vue&type=script&lang=js&"
export * from "./ModalOrderReturn.vue?vue&type=script&lang=js&"
import style0 from "./ModalOrderReturn.vue?vue&type=style&index=0&id=48ae256a&prod&lang=scss&"
import style1 from "./ModalOrderReturn.vue?vue&type=style&index=1&id=48ae256a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ae256a",
  null
  
)

export default component.exports